import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import CrudTab from '../../crud/CrudTab'
import { rentalService, carService } from '../../../services'
import PrintIcon from '@mui/icons-material/Print'
import 'toasted-notes/src/styles.css'
import { useTranslation } from 'react-i18next'
import { ToastContainer, toast } from 'react-toastify'
import Grid from '@mui/material/Grid'
import Moment from 'react-moment'

export default function TabRental(props) {
    const [filter, setFilter] = useState({
        car: null,
        user: props.idclient,
        company: props.idcompany,
        from: null,
        to: null,
        rentalState: null,
        paymentState: null,
    })

    const { t } = useTranslation()

    const createEstructureFilter = [
        {
            type: 'input',
            name: 'from',
            inputtype: 'date',
            col: 3,
        },
        {
            type: 'input',
            name: 'to',
            inputtype: 'date',
            col: 3,
        },
    ]

    const paintCell = {
        total: (value, object) => {
            if (value) {
                return <>{value.toFixed(2)}</>
            } else {
                return <></>
            }
        },
        paymentState: (value, object) => {
            if (value) {
                if (value == 'PAYMENT') return <>PAGADO</>
                else if (value == 'ERROR') return <>ERROR EN EL PAGO</>
                else if (value == 'PARCIAL') return <>PAGADO PARCIALMENTE</>
                else return <></>
            } else {
                return <></>
            }
        },
        rentalState: (value, object) => {
            if (value) {
                if (value == 'RESERVED') return <>Reservado</>
                else if (value == 'START') return <>En curso</>
                else if (value == 'END') return <>Finalizado</>
                else if (value == 'CANCEL') return <>Cancelado</>
                else if (value == 'ISSUE') return <>Con incidenica</>
                else return <></>
            } else {
                return <></>
            }
        },
        start: (value, object) => {
            if (value) {
                return <Moment date={value} format={'DD/MM/yyyy HH:mm:ss'} />
            } else {
                return <></>
            }
        },
        end: (value, object) => {
            if (value) {
                return <Moment date={value} format={'DD/MM/yyyy HH:mm:ss'} />
            } else {
                return <></>
            }
        },
        start_real: (value, object) => {
            if (value) {
                return <Moment date={value} format={'DD/MM/yyyy HH:mm:ss'} />
            } else {
                return <></>
            }
        },
        end_real: (value, object) => {
            if (value) {
                return <Moment date={value} format={'DD/MM/yyyy HH:mm:ss'} />
            } else {
                return <></>
            }
        },
    }

    useEffect(() => {}, [])

    useEffect(() => {
        setFilter({
            car: null,
            user: props.idclient,
            company: props.idcompany,
            from: null,
            to: null,
            rentalState: null,
            paymentState: null,
        })
    }, [props.idclient, props.idcompan])

    return (
        <>
            <CrudTab
                service={rentalService}
                urledit={'/rent/edit/'}
                urlnew={'/rent/new/'}
                filter={filter}
                i18n={'rental'}
                fieldstable={[
                    'car.name',
                    'start',
                    'end',
                    'start_real',
                    'end_real',
                    'total',
                ]}
                defaultValues={{ serie: '', number: 'Borrador' }}
                paintCell={paintCell}
                estructureForm={createEstructureFilter}
                haveother={false}
                editable={false}
                deleteaction={false}
                selectable={false}
            />
            <ToastContainer />
        </>
    )
}
